import axios from 'axios';
import router from 'source/router';
import store from 'source/store';

const instance = axios.create({
    baseURL: process.env.API_URL, // Injected via webpack.DefinePlugin
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
});

instance.interceptors.response.use(
    response => Promise.resolve(response.data),
    error => {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // Redirect for 403/404 errors specifically
            const { status, data } = error.response;
            const errorHandlers = {
                401: () => {
                    if (data.error == 'token') {
                        // token has expired
                        store.dispatch('auth/performLogout', true);
                    }
                    // additional 401 cases here
                },
                // Redirect to a custom 403 error page
                403: () => router.replace({ name: 'access-denied' }),
                // Redirect to a custom 404 error page
                404: () => router.replace({ name: 'page-not-found' })
            };

            const errorHandler = errorHandlers[status];
            if (errorHandler) {
                errorHandler();
            }
        };

        return Promise.reject(error);
    });

export default instance;
